import { useState, useEffect, useRef } from 'react';

// Searchable user dropdown with name preview (extracted from ProjectDetails.js)
export const UserAssignDropdown = ({ users, currentUserId, onAssign, testId }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const ref = useRef(null);
  const currentUser = users.find(u => u.id === currentUserId);

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const normalize = (s) => s?.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') || '';

  const filtered = users.filter(u => {
    if (!q) return true;
    const s = normalize(q);
    return (normalize(u.artist_name).includes(s) || normalize(u.name).includes(s));
  });

  return (
    <div className="mb-3 relative" ref={ref}>
      <button
        type="button"
        onClick={() => { setOpen(!open); setQ(''); }}
        className="w-full bg-slate-600 border border-slate-500 rounded-lg px-3 py-1.5 text-sm text-left text-white focus:outline-none focus:border-teal-500 truncate"
        data-testid={testId}
      >
        {currentUser ? (currentUser.artist_name || currentUser.name) : '-- Selecionar Dublador --'}
      </button>
      {open && (
        <div className="absolute z-30 left-0 right-0 top-full mt-1 bg-slate-700 border border-slate-500 rounded-lg shadow-xl overflow-hidden">
          <input
            type="text"
            value={q}
            onChange={e => setQ(e.target.value)}
            placeholder="Buscar..."
            className="w-full bg-slate-600 px-3 py-2 text-sm text-white border-b border-slate-500 focus:outline-none"
            autoFocus
          />
          <div className="max-h-40 overflow-y-auto">
            <button type="button" onClick={() => { onAssign(''); setOpen(false); }} className="w-full text-left px-3 py-2 text-sm text-slate-400 hover:bg-slate-600 transition-colors">
              -- Nenhum --
            </button>
            {filtered.map(u => (
              <button key={u.id} type="button" onClick={() => { onAssign(u.id); setOpen(false); }}
                className={`w-full text-left px-3 py-2 text-sm hover:bg-slate-600 transition-colors flex items-center gap-2 ${u.id === currentUserId ? 'text-teal-400' : 'text-white'}`}
              >
                {u.picture ? <img src={u.picture} alt="" className="w-5 h-5 rounded-full" /> : <div className="w-5 h-5 rounded-full bg-teal-500/20 text-teal-400 text-xs flex items-center justify-center">{u.name?.charAt(0)}</div>}
                <span className="truncate">{u.artist_name || u.name}</span>
                {u.artist_name && <span className="text-slate-500 text-xs truncate">({u.name})</span>}
              </button>
            ))}
            {filtered.length === 0 && <p className="px-3 py-2 text-sm text-slate-500">Nenhum resultado</p>}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserAssignDropdown;
